<template>
  <div>
    <DBGrid :store="store" :config="config" ref="grid" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, nextTick } from "vue";
import MedicamentWriteoffActsListController from "./ListController";
import { pageTitle } from "@/layouts/layouts";
import DBStore from "@/core/db_store";
import stateStore from "@/store";

export default defineComponent({
  props: {
    panel: { type: Object, default: () => ({}) },
    store: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const grid = ref(null);

    const user = stateStore.state.user;
    const isFullAccess =
      user.roles?.includes("admin") ||
      user.roles?.includes("chief_medical") ||
      user.roles?.includes("warehouse");
    const userConsigneeId = user.consignee_id || null;

    const initialFilters: any[] = [];
    if (!isFullAccess && userConsigneeId) {
      initialFilters.push({
        where: `("medicament_writeoff_acts"."warehouse_id" = '${userConsigneeId}' OR "medicament_writeoff_acts"."department_id" = '${userConsigneeId}')`,
        _consigneeFilter: true,
      });
    }

    const controller = new MedicamentWriteoffActsListController(
      "medicament_writeoff_acts",
      { filters: initialFilters },
      grid
    );
    const setup = controller.setup();

    onMounted(async () => {
      pageTitle.value = "";
      await nextTick();
      controller.setButtons();
    });

    return {
      grid,
      store: setup.store as DBStore,
      config: setup.config,
    };
  },
});
</script>
